import * as yup from 'yup';
import { EarmarkValueDTO } from '../../../../api/useWhatIfGroupsQuery';

export const TaxStatusValues = ['Taxable', 'TaxDeferred', 'TaxFree'];

export interface Windfall {
  WindfallYear: number | null;
  WindfallNetAmount: number | null;
  WindfallDescription: string;
  WindfallEarmark: WindfallEarmarkDTO[] | null;
  WindfallTaxStatus: string | number;
  WindfallOwnerName: string;
  TreatAsInheritedIRA: boolean;
  TreatAsInheritedRothIRA: boolean;
  IsApplied: boolean;
}

export interface WindfallEarmarkDTO {
  label: string;
  value: EarmarkValueDTO;
}

export interface WhatIfDTO {
  WhatIfKey: string;
  WhatIfType: number;
  WhatIfTypeName: string;
  WindfallEvents: Windfall[];
}

export interface FormValues extends WhatIfDTO {}

export const FORM_SCHEMA = yup.object().shape({
  WindfallEvents: yup.array().of(
    yup.object().shape({
      WindfallYear: yup
        .number()
        .nullable()
        .required('Please select the year of windfall.'),
      WindfallNetAmount: yup
        .number()
        .nullable()
        .required('Please enter the net amount of windfall.'),
      WindfallTaxStatus: yup.string().required('Please select a tax status.'),
    }),
  ),
});
